export function OarCerea() {
  return (
    <svg
      width="312.72833"
      height="650"
      viewBox="0 0 82.742702 171.97917"
      version="1.1"
      id="cerea"
    >
      <defs id="defs1" />
      <g id="layer1">
        <rect
          fill="#ffffff"
          id="rect1"
          width="82.742706"
          height="171.97917"
          x="-0.19270325"
          y="1.527482e-14"
        />
        <rect
          fill="#68b8f1"
          id="rect2"
          width="82.550003"
          height="79.684486"
          x="-1.7805311e-06"
          y="4.4231285e-14"
        />
        <path
          fill="#61CE70"
          id="path2"
          d="m 98.284616,25.97644 8.961804,-3.183757 0.25858,-9.507018 5.79729,7.539348 9.12162,-2.691903 -5.37889,7.843331 5.37888,7.843331 -9.12161,-2.691904 -5.79729,7.539348 -0.25858,-9.507019 z"
          transform="translate(-77.556824,53.708044)"
        />
      </g>
    </svg>
  );
}
